"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRead = void 0;
const Query_1 = require("../../query/Query");
function useRead(options) {
    return Query_1.useQuery(options);
}
exports.useRead = useRead;
//# sourceMappingURL=useRead.js.map